// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2204":"fa0a0701","6889":"d5d4f9dc"}[chunkId] + ".chunk.css";
};